import React, { useEffect, useState } from 'react';
import { personalInfo } from '../data/mock';
import { Linkedin, Code2, Trophy, Github, ChevronDown, ArrowUpRight } from 'lucide-react';

const HeroSection = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const socialLinks = [
    { icon: Linkedin, href: personalInfo.social.linkedin, label: 'LinkedIn' },
    { icon: Code2, href: personalInfo.social.leetcode, label: 'LeetCode' },
    { icon: Trophy, href: personalInfo.social.codeforces, label: 'Codeforces' },
    { icon: Github, href: personalInfo.social.github, label: 'GitHub' },
  ];

  return (
    <section id="about" className="min-h-screen flex items-center relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 w-full grid grid-cols-1 lg:grid-cols-5 gap-12 items-center pt-24 pb-12">
        {/* Left Content */}
        <div className="lg:col-span-3 space-y-8">
          <div className="space-y-3">
            <p
              className={`font-mono text-[13px] text-gray-400 tracking-widest uppercase transition-all duration-700 ${
                mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              Software Development Engineer
            </p>
            <h1 className="font-heading">
              <span
                className={`block text-[clamp(3.5rem,9vw,7rem)] font-[200] leading-[0.9] tracking-[-0.03em] transition-all duration-700 delay-100 ${
                  mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
              >
                Anurag
              </span>
              <span
                className={`block text-[clamp(3.5rem,9vw,7rem)] font-[200] leading-[0.9] tracking-[-0.03em] transition-all duration-700 delay-200 ${
                  mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
              >
                Pandey<span className="text-gray-200">.</span>
              </span>
            </h1>
          </div>

          <div
            className={`space-y-2 transition-all duration-700 delay-300 ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <p className="text-gray-400 text-lg max-w-lg leading-relaxed">
              {personalInfo.tagline}
            </p>
            <p className="font-mono text-[13px] text-gray-300">
              Currently building at <span className="text-black font-medium">Stamina</span>
            </p>
          </div>

          <div
            className={`flex items-center gap-5 pt-2 transition-all duration-700 delay-[400ms] ${
              mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 text-gray-400 hover:text-black transition-all duration-300"
                title={social.label}
              >
                <social.icon size={17} strokeWidth={1.5} />
                <span className="text-[12px] font-mono hidden sm:inline tracking-wide">
                  {social.label}
                </span>
                <ArrowUpRight
                  size={11}
                  className="opacity-0 -translate-x-1 -translate-y-0.5 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-300"
                />
              </a>
            ))}
          </div>
        </div>

        {/* Right: Profile Photo */}
        <div
          className={`hidden lg:flex lg:col-span-2 justify-end transition-all duration-1000 delay-500 ${
            mounted ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
          }`}
        >
          <div className="relative w-[340px] h-[340px] xl:w-[380px] xl:h-[380px]">
            {/* Outer rotating ring accent */}
            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 400">
              <g style={{ transformBox: 'fill-box', transformOrigin: 'center', animation: 'rotate-slow 40s linear infinite' }}>
                <circle cx="200" cy="200" r="198" fill="none" stroke="#e0e0e0" strokeWidth="0.5" strokeDasharray="4 12" />
                <circle cx="200" cy="2" r="1.5" fill="#ccc" />
                <circle cx="200" cy="398" r="1.5" fill="#ccc" />
              </g>
              <g style={{ transformBox: 'fill-box', transformOrigin: 'center', animation: 'rotate-slow 30s linear infinite reverse' }}>
                <circle cx="200" cy="200" r="192" fill="none" stroke="#eaeaea" strokeWidth="0.3" strokeDasharray="6 18" />
              </g>
            </svg>
            {/* Photo */}
            <div className="absolute inset-[20px] rounded-full overflow-hidden border border-gray-200/60 shadow-[0_8px_40px_rgba(0,0,0,0.08)]">
              <img
                src="/anurag.jpg"
                alt="Anurag Pandey"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div
        className={`absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 transition-all duration-700 delay-[800ms] ${
          mounted ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <span className="text-[11px] text-gray-300 font-mono tracking-widest uppercase">scroll</span>
        <ChevronDown size={14} className="text-gray-300 animate-bounce" />
      </div>
    </section>
  );
};

export default HeroSection;
